/** @format */

export const AddSizeLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_477_180)">
                <path
                    d="M24.0003 17.3333H17.3337V24C17.3337 24.7333 16.7337 25.3333 16.0003 25.3333C15.267 25.3333 14.667 24.7333 14.667 24V17.3333H8.00033C7.26699 17.3333 6.66699 16.7333 6.66699 16C6.66699 15.2667 7.26699 14.6667 8.00033 14.6667H14.667V7.99999C14.667 7.26666 15.267 6.66666 16.0003 6.66666C16.7337 6.66666 17.3337 7.26666 17.3337 7.99999V14.6667H24.0003C24.7337 14.6667 25.3337 15.2667 25.3337 16C25.3337 16.7333 24.7337 17.3333 24.0003 17.3333Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_477_180">
                    <rect width="32" height="32" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};
